export enum PartnerNames {
  stauffacher = "Stauffacher Apotheke",
  s24 = "Sante24",
  sanitas = "Sanitas",
  css = "CSS",
  larsKoschorreck = "Lars Koschorreck",
  gynpoint = "Dr. Alina Staikov",
  stefanZechmann = "Dr.Stefan Zechmann",
};